import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Component, inject, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-sliding-two-column-layout',
  imports: [],
  templateUrl: './sliding-two-column-layout.component.html',
  styleUrl: './sliding-two-column-layout.component.scss'
})
export class SlidingTwoColumnLayoutComponent implements OnInit {

  private breakpointObserver = inject(BreakpointObserver);

  public isHandset: boolean = false;

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => { 
      this.isHandset = state.matches; 
    }); 
      
    this.breakpointObserver.observe([ Breakpoints.Tablet, Breakpoints.Web, Breakpoints.WebLandscape ]).subscribe((state: BreakpointState) => { 
      this.isHandset = !state.matches; 
    });
  }

  public openLeftPanel() {
    console.log('Drawer Open');
  }

  public closeLeftPanel() {
    console.log('Drawer Close');
  }

  public toggleLeftPanel() {
    console.log('Drawer Toggle');
  }

}
